@if (product$ | async; as product) {
    @let isMobileApp = isMobileApp$ | async;
    <div [ngClass]="{ 'modal-dialog': modal }">
        <div class="product-content">
            <div #modalContent [ngClass]="{ 'modal-content': modal }">
                <div class="container noPrint" [ngClass]="{ 'sticky-modal-header': modal }">
                    <div class="row no-gutters noPrint" [ngClass]="{ 'modal-header': modal }">
                        @if (!isMobileApp) {
                            <div [ngClass]="modal ? 'col-md-10 col-8' : 'col-12'">
                                <aimo-breadcrumb
                                    [hideTitle]="true"
                                    [productTitle]="product.name"
                                    [addFrontPageLink]="true"
                                    [breadCrumbs]="getBreadcrumbs(product)"
                                    [skipMetaBreadCrumbs]="true"
                                    [showBackLink]="false">
                                </aimo-breadcrumb>
                            </div>
                        }
                        @if (modal) {
                            <div class="modal-action col-auto">
                                @if (!isMobileApp) {
                                    <button
                                        [tabIndex]="9999"
                                        class="btn-link open-product-page mr-3 noPrint"
                                        [attr.aria-label]="'aimo.product.open.product' | cxTranslate"
                                        (keydown.tab)="getTheFocusBack($event)">
                                        @if (!isInSmartEditMode()) {
                                            <a
                                                #productLink
                                                [routerLink]="product.url"
                                                [queryParams]="getQueryParams(inheritedGTMProductAttributes?.gtmParams)"
                                                target="_blank">
                                                <i class="aimo-icon icon-md icon-inline icon-arrow-square-out"></i>
                                            </a>
                                        }
                                        @if (isInSmartEditMode()) {
                                            <a #productLink (click)="openProductInSmartEdit(product)">
                                                <i class="aimo-icon icon-md icon-inline icon-arrow-square-out"></i>
                                            </a>
                                        }
                                    </button>
                                }
                                <button
                                    #closeButton
                                    class="btn-link"
                                    [attr.aria-label]="'aimo.arialLabel.close.modal' | cxTranslate">
                                    <i class="aimo-icon icon-md icon-inline icon-x" (click)="closeDialog()"></i>
                                </button>
                            </div>
                        }
                    </div>
                </div>
                <div class="container">
                    <div class="row no-gutters" [ngClass]="{ 'modal-body': modal }">
                        <div class="onlyPrint mb-4">
                            <cx-page-slot position="SiteLogo"></cx-page-slot>
                        </div>
                        <div class="col-12 summary-grid">
                            <div class="header">
                                <div class="mb-2">
                                    <aimo-product-tag [product]="product"/>
                                    @if (product.icons?.length > 0) {
                                        <div class="float-right d-inline-block d-md-none noPrint">
                                            @for (icon of product.icons; track icon) {
                                                <i class="aimo-icon icon-md icon-inline ml-2 {{ icon }}"></i>
                                            }
                                        </div>
                                    }
                                </div>
                                <h1 class="product-name">{{ product.name }}</h1>
                                <div class="text-dark-grey product-code">
                                    @if (product.favorite) {
                                        <i
                                            class="aimo-icon icon-inline icon-dark-grey icon-sm icon-inline mr-3 icon-star-filled"
                                            triggers="mouseenter:mouseleave"
                                            placement="bottom"
                                            container="body"
                                            [ngbPopover]="'aimo.favorite.added' | cxTranslate"></i>
                                    }
                                    @if (product.frozenProduct) {
                                        <i
                                            class="aimo-icon icon-inline icon-dark-grey icon-sm icon-inline mr-3 icon-snow-flake"
                                            triggers="mouseenter:mouseleave"
                                            popoverClass="popover-default"
                                            container="body"
                                            role="img"
                                            [attr.aria-label]="'aimo.product.frozenProduct' | cxTranslate"
                                            [ngbPopover]="'aimo.product.frozenProduct' | cxTranslate"></i>
                                    }
                                    <span class="mr-3 ml-0">{{ product.code }} </span>
                                    @if (product.lotSizeInfo) {
                                        <span class="mr-3">{{ product.lotSizeInfo }}</span>
                                    }
                                    <span class="mr-3">{{
                                            'productDetails.ean' | cxTranslate: {ean: product.ean}
                                        }}</span>
                                    @if (product.lastPurchased) {
                                        <span class="mr-3 d-inline-block">
                                            <i
                                                class="aimo-icon icon-sm icon-clock-counter-clockwise icon-inline icon-dark-grey"></i>
                                            <span class="d-inline-block">
                                                <span>{{ getLastPurchasedTranslationKey(product) | cxTranslate }}</span>
                                                <span class="text-left-space">{{
                                                        product.lastPurchased | cxDate: ('aimo.dateFormat' | cxTranslate)
                                                    }}</span>
                                            </span>
                                        </span>
                                    }
                                </div>
                            </div>
                            <div class="content text-center">
                                @if (product.icons.length > 0) {
                                    <div class="text-right pb-3 d-none d-md-block print">
                                        @for (icon of product.icons; track icon) {
                                            <i
                                                class="aimo-icon icon-inline ml-2 {{ icon }}"
                                                [ngClass]="
                                                    icon === 'rainforest' || icon === 'icon-green-swan'
                                                        ? 'icon-lg'
                                                        : 'icon-lg2'
                                                "></i>
                                        }
                                    </div>
                                }
                                <aimo-product-images
                                    [modal]="modal"
                                    [product]="product"
                                    [gtmParams]="inheritedGTMProductAttributes?.gtmParams"></aimo-product-images>
                            </div>
                            <div class="footer">
                                <div class="mb-2">
                                    @if (product.pikatukkuWebShopProduct) {
                                        <div class="d-inline-block mr-3 mb-3 web-shop-product">
                                            {{ 'aimo.product.shopProduct' | cxTranslate }}
                                        </div>
                                    }
                                    <div class="cx-stock d-inline-block mr-3">
                                        @if (!isPikatukku()) {
                                            <aimo-product-availability [stock]="product.stock">
                                            </aimo-product-availability>
                                        }
                                        @if (isPikatukku()) {
                                            @for (ptstock of product.pikatukkuStock; track ptstock.warehouse.code) {
                                                <div class="cx-stock">
                                                    <aimo-product-availability
                                                        [suggestiveMode]="true"
                                                        [printStockName]="true"
                                                        [stock]="ptstock">
                                                    </aimo-product-availability>
                                                </div>
                                            }
                                        }
                                    </div>
                                    @if (product.stock?.closingTime) {
                                        <div class="product-closing-time d-inline-block mr-3">
                                            <i class="aimo-icon icon-inline icon-dark-grey icon-clock icon-sm"></i>
                                            <span>{{
                                                    'productDetails.closeAt'
                                                        | cxTranslate
                                                        : {
                                                            time:
                                                                (convertDate(product.stock?.closingTime)
                                                                    | cxDate: 'HH:mm'),
                                                        }
                                                }}</span>
                                        </div>
                                    }
                                    @if (product.pikatukkuStock.length > 0 && !isPikatukku()) {
                                        <button
                                            class="product-wholesales-availability btn-link d-inline-block noPrint"
                                            placement="top"
                                            container="body"
                                            [ngbPopover]="pikatukkuStock"
                                            popoverClass="popover-stock-tooltip">
                                            <i class="aimo-icon icon-inline icon-dark-grey icon-storefront icon-sm"></i>
                                            <span>{{ 'productDetails.availabilty.wholesales' | cxTranslate }}</span>
                                        </button>
                                    }
                                </div>
                                @if (product.stock.salesBlockStart) {
                                    <div class="messages">
                                        <div class="message message-WARNING">
                                            <i class="left-side aimo-icon icon-inline icon-WARNING icon-red"></i>
                                            @if (!product.stock.salesBlockEnd) {
                                                <span class="ml-2">{{
                                                        'aimo.product.salesBlockProductClosing'
                                                            | cxTranslate
                                                            : {
                                                                date:
                                                                    product.stock.salesBlockStart
                                                                        | cxDate: ('aimo.dateFormat' | cxTranslate),
                                                            }
                                                    }}</span>
                                            }
                                            @if (product.stock.salesBlockEnd) {
                                                <span class="ml-2"
                                                >{{
                                                        'aimo.product.salesBlockSpan'
                                                            | cxTranslate
                                                            : {
                                                                from:
                                                                    product.stock.salesBlockStart
                                                                        | cxDate: ('aimo.dateFormat' | cxTranslate),
                                                                to:
                                                                    product.stock.salesBlockEnd
                                                                        | cxDate: ('aimo.dateFormat' | cxTranslate),
                                                            }
                                                    }}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                }
                                <ng-template #pikatukkuStock>
                                    @for (ptstock of product.pikatukkuStock; track ptstock.warehouse.code) {
                                        <div class="cx-stock">
                                            <aimo-product-availability
                                                [suggestiveMode]="true"
                                                [printStockName]="true"
                                                [stock]="ptstock">
                                            </aimo-product-availability>
                                        </div>
                                    }
                                </ng-template>
                                @if (product.price) {
                                    <div class="price row no-gutters flex-nowrap">
                                        <div class="col-auto prices pr-lg-0 pr-md-5 mb-md-3 mb-0 mb-lg-0">
                                            <div class="active-price mb-1">
                                                @if (product.myAssortment) {
                                                    @if (myAssortmentLabelSuffix$ | async; as myAssortmentLabelSuffix) {
                                                        <i
                                                            placement="right"
                                                            container="body"
                                                            triggers="mouseenter:mouseleave"
                                                            [ngbPopover]="
                                                                'aimo.product.myAssortment' +
                                                                    myAssortmentLabelSuffix.suffix | cxTranslate
                                                            "
                                                            class="aimo-icon icon-inline icon-md icon-house-line"
                                                            [ngClass]="
                                                                product.strikeThroughPrice
                                                                    ? 'icon-red'
                                                                    : 'icon-petrol-blue'
                                                            "></i>
                                                    }
                                                }
                                                <span
                                                    class="text-bold align-baseline"
                                                    [ngClass]="
                                                        product.strikeThroughPrice
                                                            ? 'promo-price'
                                                            : product.myAssortment
                                                              ? 'my-assortment-price'
                                                              : ''
                                                    ">
                                                    <span class="price-value">{{ product.price?.formattedValue }}</span>
                                                    / {{ product.unit?.name }}
                                                </span>
                                                @if (product.strikeThroughPrice) {
                                                    <span class="text-strike text-dark-grey align-baseline">
                                                        {{ product.strikeThroughPrice.formattedValue }}
                                                    </span>
                                                }
                                                @if (product.taxPercentage > 0) {
                                                    <span class="text-dark-grey ml-1"
                                                    >{{
                                                            'aimo.product.vat'
                                                                | cxTranslate: {amount: product.taxPercentage}
                                                        }}
                                                    </span>
                                                }
                                            </div>

                                            @if (product.strikeThroughPrice) {
                                                <div
                                                    class="price-validity mb-3"
                                                    [innerHTML]="
                                                        'aimo.product.promoPriceValidity'
                                                            | cxTranslate
                                                                : {
                                                                      from:
                                                                          convertDate(product.price.validFrom)
                                                                          | cxDate
                                                                              : ('aimo.dateFormatNoYear' | cxTranslate),
                                                                      to:
                                                                          convertDate(product.price.validTo)
                                                                          | cxDate: ('aimo.dateFormat' | cxTranslate),
                                                                  }
                                                    "></div>
                                            }

                                            @if (product.comparisonPrice) {
                                                <div class="comparison-price">
                                                    {{ product.comparisonPrice.formattedValue }}
                                                    / {{ product.comparisonUnit?.name }}
                                                    @if (product.taxPercentageCatalogPrice === 0) {
                                                        <span>
                                                            {{
                                                                'aimo.product.vat'
                                                                    | cxTranslate: {amount: product.taxPercentage}
                                                            }}
                                                        </span>
                                                    }
                                                </div>
                                            }

                                            <div class="comparison-price">
                                                {{ product.priceWithTax?.formattedValue }}
                                                / {{ product.unit?.name }}
                                                {{
                                                    'aimo.product.vat'
                                                        | cxTranslate: {amount: product.taxPercentageCatalogPrice}
                                                }}
                                            </div>
                                        </div>
                                        @if (!isMobileApp || !isPikatukku()) {
                                            <div
                                                class="col-auto add-to-cart pl-lg-5 pl-md-0 pl-2 ml-auto ml-md-0 noPrint">
                                                <aimo-cx-add-to-cart
                                                    class="ml-2 ml-md-0 ml-lg-2 d-inline float-right add-product-details"
                                                    [product]="product"
                                                    [gtmProductAttributes]="
                                                        createGtmProductAttributes(0, productSummary, product)
                                                    "
                                                    [showQuantity]="true"
                                                    [isPLP]="modal ? true : false"
                                                    [options]="{
                                                        displayAddToCart: true,
                                                        addToCartString: '',
                                                    }"
                                                    (afterChange)="onProductChange($event)">
                                                </aimo-cx-add-to-cart>
                                            </div>
                                        }
                                    </div>
                                }

                                @if (product.price) {
                                    @if ((!isPikatukku() || !product.pikatukkuWebShopProduct) &&
                                    !product.purchasable &&
                                    product.stock.stockLevelStatus === 'outOfStock') {
                                        <div class="mt-4">
                                            <button
                                                [ngbPopover]="
                                                    product.availabilityNotificationActive
                                                        ? ('aimo.product.removeAvailabilityNotification' | cxTranslate)
                                                        : ('aimo.product.addAvailabilityNotificationTooltip'
                                                          | cxTranslate)
                                                "
                                                container="body"
                                                triggers="mouseenter:mouseleave"
                                                popoverClass="popover-sm"
                                                placement="top"
                                                class="btn btn-secondary btn-sm btn-block-sm-down"
                                                type="button"
                                                (click)="toggleAvailabilityNotification(product)"
                                                tabindex="0">
                                                <i
                                                    class="aimo-icon icon-petrol-blue icon-inline mr-2 mb-1 noPrint"
                                                    [ngClass]="
                                                        product.availabilityNotificationActive
                                                            ? 'icon-bell-slash'
                                                            : 'icon-bell'
                                                    "></i>
                                                {{
                                                    product.availabilityNotificationActive
                                                        ? ('aimo.product.removeAvailabilityNotification' | cxTranslate)
                                                        : ('aimo.product.addAvailabilityNotification' | cxTranslate)
                                                }}
                                            </button>
                                        </div>
                                    }
                                }
                                <div class="pt-4 product-description">
                                    @if (truncate(product.description)) {
                                        @if (!showDescription) {
                                            <span class="noPrint">{{ truncate(product.description) }}</span>
                                            <span class="onlyPrint">{{ product.description }}</span>
                                            <button
                                                class="btn-link text-md ml-1 noPrint"
                                                [attr.aria-label]="
                                                    'aimo.product.arialLabel.showMoreDescription' | cxTranslate
                                                "
                                                (click)="toggleDescription()">
                                                {{ 'aimo.product.showMoreDescription' | cxTranslate }}
                                            </button>
                                        }
                                        @if (showDescription) {
                                            {{ product.description }}
                                            <button
                                                class="btn-link text-md ml-1"
                                                [attr.aria-label]="
                                                    'aimo.product.arialLabel.showLessDescription' | cxTranslate
                                                "
                                                (click)="toggleDescription()">
                                                {{ 'aimo.product.showLessDescription' | cxTranslate }}
                                            </button>
                                        }
                                    }
                                    @if (!truncate(product.description)) {
                                        {{ product.description }}
                                    }
                                </div>
                                @if (getClassification(product, 'allergens')?.length > 0) {
                                    <div>
                                        <h5>{{ getClassificationName(product, 'allergens') }}</h5>
                                        {{ getClassificationValueList(product, 'allergens') }}
                                    </div>
                                }
                            </div>
                        </div>
                        @if (user$ | async; as user) {
                            <div class="col-12">
                                <div class="product-actions noPrint">
                                    <div class="row">
                                        @if (loggedUser$ | async) {
                                            <button
                                                (click)="toggleFavorite(product)"
                                                class="d-inline col-md-auto col-6 btn-link">
                                                <i
                                                    class="aimo-icon icon-sm icon-inline"
                                                    [ngClass]="{
                                                        'icon-star-filled': product.favorite,
                                                        'icon-star': !product.favorite,
                                                    }"></i>
                                                <span>{{
                                                        (product.favorite ? 'aimo.favorite.remove' : 'aimo.favorite.add')
                                                            | cxTranslate
                                                    }}</span>
                                            </button>
                                        }
                                        @if (!isPikatukku() &&
                                        (user.customerAdmin || !user.isHideNormalOrderTemplatesFromBasicUsers)) {
                                            <button
                                                [id]="'product_summary_add_to_order_template'"
                                                class="d-inline col-md-auto col-6 btn-link"
                                                (click)="
                                                    addToOrderTemplate(product, 'product_summary_add_to_order_template')
                                                ">
                                                <i class="aimo-icon icon-file-plus icon-sm icon-inline"></i>
                                                <span>{{ 'aimo.product.addToTemplate' | cxTranslate }}</span>
                                            </button>
                                        }
                                        <button
                                            [id]="'product_summary_add_comparison'"
                                            class="d-none d-lg-inline col-md-auto col-6 btn-link"
                                            (click)="addToComparison(product)">
                                            <i class="aimo-icon icon-arrow-left-right icon-sm icon-inline"></i>
                                            <span>{{ 'aimo.product.actions.comparison' | cxTranslate }}</span>
                                        </button>
                                        @if (!isMobileApp) {
                                            <button
                                                [id]="'product_summary_print'"
                                                class="d-inline col-md-auto col-6 btn-link"
                                                (click)="print()">
                                                <i class="aimo-icon icon-printer icon-sm icon-inline"></i>
                                                <span>{{ 'aimo.product.actions.print' | cxTranslate }}</span>
                                            </button>
                                            <button
                                                [id]="'product_summary_copy_url'"
                                                class="d-inline col-md-auto col-6 btn-link"
                                                [aimoCopyClipboard]="getFullUrl()">
                                                <i class="aimo-icon icon-link icon-sm icon-inline"></i>
                                                <span>{{ 'aimo.product.actions.copyLink' | cxTranslate }}</span>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <cx-page-slot position="ProductReferences"></cx-page-slot>
                @if (product.productReferences[SIMILAR_PRODUCTS]?.length > 0 &&
                product.productReferences[CROSSSELING_PRODUCTS]?.length > 0) {
                    @if (getSimilarProducts(product) | async; as similar) {
                        @if (getCrossSellingProducts(product) | async; as cr) {
                            <div class="aimo-tabbed-container noPrint">
                                <a class="anchor" id="similar-products-container">{{ similar.title }}</a>
                                <div class="aimo-background bg-petrol-light"></div>
                                <div class="container">
                                    <div class="aimo-tab-wrapper">
                                        <div class="aimo-tab-border">
                                            <div class="tab-items tab-items-lg d-flex align-items-center">
                                                <div
                                                    id="tab_0"
                                                    (click)="setActiveTab(similar, $event)"
                                                    class="tab-item tab-item-auto-width tab-item-border-transparent cursor-pointer"
                                                    [ngClass]="{ active: isActiveTab(similar, 0) }">
                                                    {{ similar.title }}
                                                </div>

                                                <div
                                                    id="tab_1"
                                                    (click)="setActiveTab(cr, $event)"
                                                    class="tab-item tab-item-auto-width tab-item-border-transparent cursor-pointer"
                                                    [ngClass]="{ active: isActiveTab(cr, 1) }">
                                                    {{ cr.title }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-content">
                                        @if (isActiveTab(similar, 0)) {
                                            <aimo-cx-carousel
                                                class="carousel-products"
                                                role="region"
                                                tabindex="-1"
                                                itemWidth="10px"
                                                [hideIndicators]="true"
                                                [items]="similar.carouselProducts"
                                                [title]="similar.title"
                                                [template]="carouselItem"
                                                [idSuffix]="'similar_product'"
                                                [gtmParams]="getGtmParams(alternative)">
                                            </aimo-cx-carousel>
                                        }
                                    </div>

                                    <div class="tab-content">
                                        @if (isActiveTab(cr, 1)) {
                                            <aimo-cx-carousel
                                                class="carousel-products"
                                                role="region"
                                                tabindex="-1"
                                                itemWidth="10px"
                                                [hideIndicators]="true"
                                                [items]="cr.carouselProducts"
                                                [title]="cr.title"
                                                [template]="carouselItem"
                                                [idSuffix]="'crossselling_product'"
                                                [gtmParams]="getGtmParams(crossSelling)">
                                            </aimo-cx-carousel>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    }
                } @else {
                    @if (product.productReferences[SIMILAR_PRODUCTS]?.length > 0) {
                        <div class="carousel-container noPrint">
                            @if (getSimilarProducts(product) | async; as similar) {
                                <a class="anchor" id="similar-products-container">{{ similar.title }}</a>
                                <aimo-cx-carousel
                                    class="carousel-products"
                                    role="region"
                                    tabindex="-1"
                                    itemWidth="10px"
                                    [hideIndicators]="true"
                                    [items]="similar.carouselProducts"
                                    [title]="similar.title"
                                    [template]="carouselItem"
                                    [idSuffix]="'similar_product'"
                                    [gtmParams]="getGtmParams(alternative)">
                                </aimo-cx-carousel>
                            }
                        </div>
                    }
                    @if (product.productReferences[CROSSSELING_PRODUCTS]?.length > 0) {
                        <div class="carousel-container noPrint">
                            @if (getCrossSellingProducts(product) | async; as cr) {
                                <aimo-cx-carousel
                                    class="carousel-products"
                                    role="region"
                                    tabindex="-1"
                                    itemWidth="10px"
                                    [hideIndicators]="true"
                                    [items]="cr.carouselProducts"
                                    [title]="cr.title"
                                    [template]="carouselItem"
                                    [idSuffix]="'crossselling_product'"
                                    [gtmParams]="getGtmParams(crossSelling)">
                                </aimo-cx-carousel>
                            }
                        </div>
                    }
                }
                <div class="container">
                    <div class="row no-gutters" [ngClass]="{ 'modal-body': modal }">
                        <div class="data-table col-12">
                            <div class="row">
                                <div class="col-md-6 col-12 table-left pr-md-4 order-md-1">
                                    <h3 class="mb-0">{{ 'productDetails.nutritional.content' | cxTranslate }}</h3>
                                    <div class="table-responsive" #nutritionalContent>
                                        @if (getClassificationClass(product, 'nutritionFact')) {
                                            <table class="table mt-4">
                                                <thead>
                                                <tr class="no-border">
                                                    <th class="text-bold table-divider bg-petrol-light">
                                                        {{ getClassificationClass(product, 'nutritionFact').name }}
                                                    </th>
                                                    <th class="text-bold table-divider bg-petrol-light text-right">
                                                        / {{ product.nutritionalContentBasisQuantity }}
                                                        {{ product.nutritionalContentBasisQuantityUnit?.name }}
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    @if (getClassificationName(product, 'ENER-E14')) {
                                                        <tr>
                                                            <td class="table-data">
                                                                {{ getClassificationName(product, 'ENER-E14') }}
                                                            </td>
                                                            <td class="text-right table-data">
                                                                {{
                                                                    getClassificationValueWithUnit(
                                                                        product,
                                                                        'ENER-E14',
                                                                        true
                                                                    )
                                                                }}
                                                                /
                                                                {{
                                                                    getClassificationValueWithUnit(
                                                                        product,
                                                                        'ENER-KJO',
                                                                        true
                                                                    )
                                                                }}
                                                            </td>
                                                        </tr>
                                                    }
                                                    @for (nutitionName of nutritionFactNames; track nutitionName) {
                                                        <ng-container
                                                            [ngTemplateOutletContext]="{
                                                                product: product,
                                                                name: nutitionName,
                                                            }"
                                                            [ngTemplateOutlet]="nutritionFact"></ng-container>
                                                    }
                                                </tbody>
                                            </table>
                                        }
                                        @if (getClassificationClass(product, 'vitamin')) {
                                            <table class="table mt-4">
                                                <thead>
                                                <tr class="no-border">
                                                    <th class="text-bold table-divider bg-petrol-light">
                                                        {{ getClassificationClass(product, 'vitamin').name }}
                                                    </th>
                                                    <th class="text-bold table-divider bg-petrol-light text-right">
                                                        / {{ product.nutritionalContentBasisQuantity }}
                                                        {{ product.nutritionalContentBasisQuantityUnit?.name }}
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    @for (vitaminName of vitaminNames; track vitaminName) {
                                                        <ng-container
                                                            [ngTemplateOutletContext]="{
                                                                product: product,
                                                                name: vitaminName,
                                                            }"
                                                            [ngTemplateOutlet]="nutritionFact"></ng-container>
                                                    }
                                                </tbody>
                                            </table>
                                        }
                                        @if (getClassificationClass(product, 'mineral')) {
                                            <table class="table mt-4">
                                                <thead>
                                                <tr class="no-border">
                                                    <th class="text-bold table-divider bg-petrol-light">
                                                        {{ getClassificationClass(product, 'mineral').name }}
                                                    </th>
                                                    <th class="text-bold table-divider bg-petrol-light text-right">
                                                        / {{ product.nutritionalContentBasisQuantity }}
                                                        {{ product.nutritionalContentBasisQuantityUnit?.name }}
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    @for (mineralName of mineralNames; track mineralName) {
                                                        <ng-container
                                                            [ngTemplateOutletContext]="{
                                                                product: product,
                                                                name: mineralName,
                                                            }"
                                                            [ngTemplateOutlet]="nutritionFact"></ng-container>
                                                    }
                                                </tbody>
                                            </table>
                                        }
                                    </div>
                                </div>

                                <div class="col-md-6 col-12 order-md-2 order-first table-right">
                                    <h3>{{ 'productDetails.specification' | cxTranslate }}</h3>
                                    @if (product.keyIngredients) {
                                        <div class="text-bold mt-4">
                                            @if (product.ingredients?.length > 0) {
                                                {{ 'aimo.product.keyIngredients' | cxTranslate }}
                                            } @else {
                                                {{ 'aimo.product.keyIngredients' | cxTranslate }}
                                            }
                                        </div>
                                        {{ product.keyIngredients }}

                                        @if (product.ingredients?.length > 0) {
                                            <button class="btn-link ml-1" (click)="toggleIngredients(product)">
                                                <span>{{
                                                        (ingredientsOpened
                                                                ? 'aimo.product.showLessDescription'
                                                                : 'aimo.product.showMoreDescription'
                                                        ) | cxTranslate
                                                    }}</span>
                                            </button>
                                        }
                                    }
                                    @if (product.manualKeyIngredients) {
                                        <div class="text-bold mt-4">
                                            {{ 'aimo.product.manualKeyIngredients' | cxTranslate }}
                                        </div>
                                        {{ product.manualKeyIngredients }}
                                    }
                                    @if (ingredientsOpened) {
                                        <ul class="ingredient-origins">
                                            @for (ingredient of product.ingredients; track ingredient.name) {
                                                <li>
                                                    <span class="text-bold">{{ ingredient.name }}</span>
                                                    <span>{{ getIngredientOrigins(ingredient) }}</span>
                                                </li>
                                            }
                                        </ul>
                                    }
                                    @if (getNutritionalContent(product, 'allergen')) {
                                        <div class="text-bold mt-4">
                                            {{ getNutritionalContent(product, 'allergen').name }}
                                        </div>
                                        {{ getClassificationNameList(product, 'allergen') }}
                                    }
                                    @if (getNutritionalContent(product, 'nutritionalClaim')) {
                                        <div class="text-bold mt-4">
                                            {{ getNutritionalContent(product, 'nutritionalClaim').name }}
                                        </div>
                                        {{ getClassificationNameList(product, 'nutritionalClaim') }}
                                    }
                                    @if (product.preparationInstructions) {
                                        <div class="text-bold mt-4">
                                            {{ 'aimo.product.preparationInstructions' | cxTranslate }}
                                        </div>
                                        {{ product.preparationInstructions }}
                                    }
                                    @if (product.usageInstructions) {
                                        <div class="text-bold mt-4">
                                            {{ 'aimo.product.usageInstructions' | cxTranslate }}
                                        </div>
                                        {{ product.usageInstructions }}
                                    }
                                    @if (product.storageInstructions) {
                                        <div class="text-bold mt-4">
                                            {{ 'aimo.product.storageInstructions' | cxTranslate }}
                                        </div>
                                        {{ product.storageInstructions }}
                                    }
                                    @if (product.safetyData?.length > 0) {
                                        <div class="text-bold mt-4">
                                            {{ 'aimo.product.safetyData' | cxTranslate }}
                                        </div>
                                        <div>
                                            <button class="btn-link text-left" (click)="safetyDataExport(product)">
                                                <i class="aimo-icon icon-simple-download icon-sm icon-inline ml-1"></i>
                                                <span>{{ 'aimo.product.safetyDataDownload' | cxTranslate }}</span>
                                            </button>
                                        </div>
                                    }
                                    @if (product.countriesOfOrigin) {
                                        <div>
                                            <div class="text-bold mt-4">
                                                {{ 'aimo.product.countryOfOrigin' | cxTranslate }}
                                            </div>
                                            @for (country of product.countriesOfOrigin; track country) {
                                                <div>
                                                    {{ country.name }}
                                                </div>
                                            }
                                        </div>
                                    }
                                    @if (product.vendor?.name) {
                                        <div class="text-bold mt-4">{{ 'aimo.product.vendor' | cxTranslate }}</div>
                                        {{ product.vendor?.name }}
                                    }
                                    @if (product.fishingInformation?.length > 0) {
                                        @for (fishInfo of product.fishingInformation; track fishInfo) {
                                            <div>
                                                <div class="text-bold mt-4">
                                                    {{ 'aimo.product.fishingInformation' | cxTranslate }}
                                                    {{ fishInfo.species }} ({{ fishInfo.speciesLatinName }}):
                                                </div>
                                                @for (catchInformation of fishInfo.catchInformation; track catchInformation) {
                                                    <span>
                                                        <span class="text-bold mt-4">
                                                            {{ 'aimo.product.productionMethod' | cxTranslate }}
                                                        </span>
                                                        {{ catchInformation.productionMethod }},
                                                        <span class="text-bold mt-4">
                                                            {{ 'aimo.product.catchMethod' | cxTranslate }}
                                                        </span>
                                                        {{ catchInformation.catchMethod }},
                                                        <span class="text-bold mt-4">
                                                            {{ 'aimo.product.catchArea' | cxTranslate }}
                                                        </span>
                                                        {{ catchInformation.catchArea }}
                                                    </span>
                                                }
                                            </div>
                                        }
                                    }
                                    <div>
                                        <div class="text-bold mt-4">
                                            {{ 'aimo.product.unitConversions' | cxTranslate }}
                                        </div>
                                        @for (uc of product.unitConversions; track uc) {
                                            <div>
                                                <div>
                                                    1 {{ uc.unit.name }} = {{ uc.conversionToBaseUnit }}
                                                    {{ product.baseUnit.name }}
                                                    @if (uc.ean) {
                                                        (EAN {{ uc.ean }})
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
<ng-template #nutritionFact let-name="name" let-product="product" let-intend="intend">
    @if (getClassificationName(product, name)) {
        <tr>
            <td class="table-data" [ngClass]="{ intend: intend }">
                {{ getClassificationName(product, name) }}
            </td>
            <td class="table-data text-right">
                {{ getClassificationValueWithUnit(product, name) }}
            </td>
        </tr>
    }
</ng-template>

<ng-template #carouselItem let-item="item" let-index="index" let-idSuffix="idSuffix" let-gtmListId="gtmListId">
    <aimo-product-grid-item
        [showCrossSelling]="false"
        [showComparison]="false"
        [product]="item"
        [idSuffix]="idSuffix + '_' + index"
        [gtmProductAttributes]="createGtmProductAttributes(index, gtmListId, item)"
        [openProductPageFromLink]="!modal">
    </aimo-product-grid-item>
</ng-template>
